<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <HostHeaderActions v-if="isHostsRoute" />
        <CustomerHeaderActions v-if="isCustomersRoute" />
        <HausefulUsersHeaderActions v-if="isHausefulUsersRoute" />
        <ServiceProvidersHeaderActions v-if="isServiceProvidersRoute" />
      </template>
    </h-header>
    <router-view ref="usersRouterView" />
  </div>
</template>

<script>
import HostHeaderActions from '@/components/host/fragments/HostHeaderActions'
import CustomerHeaderActions from '@/components/customer/fragments/CustomerHeaderActions'
import HausefulUsersHeaderActions from '@/views/hausefulUsers/fragments/HausefulUsersHeaderActions'
import ServiceProvidersHeaderActions from './serviceProvider/fragments/ServiceProvidersHeaderActions.vue'

export default {
  name: 'Users',

  components: {
    HostHeaderActions,
    CustomerHeaderActions,
    HausefulUsersHeaderActions,
    ServiceProvidersHeaderActions,
  },

  computed: {
    isHostsRoute() {
      return this.$route.path.includes('hosts')
    },

    isCustomersRoute() {
      return this.$route.path.includes('customers')
    },

    isHausefulUsersRoute() {
      return this.$route.path.includes('hauseful-users')
    },

    isServiceProvidersRoute() {
      return this.$route.path.includes('service-providers')
    },
  }
}
</script>
